import React from "react";
import MdmFullyFleetControls from "./MdmFullyFleetControls";

const MdmFleetControls = ({
  displayedDevices,
  exportCurrentViewToExcel,
  openCommandModal,
  openFieldCommandModal,
  onRestartCache,
  isRestartingCache,
  moveTarget,
  setMoveTarget,
  isMovingDevices,
  retailerNames,
  allDevices,
  folderOptions,
  selectedDevicesHomeBranchKey,
  onMoveSelected,
  selectedDeviceIds,
  showFieldCommandButton,
  triggeredSwanSongDeviceIds,
  onShowSwanSongResults,
  triggeredCameraDevices,
  onShowCameraResults,
  showLocationVersionButton,
  onOpenLocationVersionWindow,
  canEditDeviceNotes,
  onEditSelectedNotes,
  isSavingBulkNotes,
  showFieldStatusIndicators,
  fieldStatusCounts,
  selectedFieldJourneyStatus,
  onFieldJourneyStatusFilterToggle,
  onRefreshFieldStatus,
  isRefreshingFieldStatus,
}) => (
  <MdmFullyFleetControls
    displayedDevices={displayedDevices}
    exportCurrentViewToExcel={exportCurrentViewToExcel}
    openCommandModal={openCommandModal}
    openFieldCommandModal={openFieldCommandModal}
    showFieldCommandButton={showFieldCommandButton}
    onRestartCache={onRestartCache}
    isRestartingCache={isRestartingCache}
    moveTarget={moveTarget}
    setMoveTarget={setMoveTarget}
    isMovingDevices={isMovingDevices}
    retailerNames={retailerNames}
    allDevices={allDevices}
    folderOptions={folderOptions}
    selectedDevicesHomeBranchKey={selectedDevicesHomeBranchKey}
    onMoveSelected={onMoveSelected}
    selectedDeviceIds={selectedDeviceIds}
    triggeredSwanSongDeviceIds={triggeredSwanSongDeviceIds}
    onShowSwanSongResults={onShowSwanSongResults}
    triggeredCameraDevices={triggeredCameraDevices}
    onShowCameraResults={onShowCameraResults}
    showLocationVersionButton={showLocationVersionButton}
    onOpenLocationVersionWindow={onOpenLocationVersionWindow}
    canEditDeviceNotes={canEditDeviceNotes}
    onEditSelectedNotes={onEditSelectedNotes}
    isSavingBulkNotes={isSavingBulkNotes}
    showFieldStatusIndicators={showFieldStatusIndicators}
    fieldStatusCounts={fieldStatusCounts}
    selectedFieldJourneyStatus={selectedFieldJourneyStatus}
    onFieldJourneyStatusFilterToggle={onFieldJourneyStatusFilterToggle}
    onRefreshFieldStatus={onRefreshFieldStatus}
    isRefreshingFieldStatus={isRefreshingFieldStatus}
  />
);

export default MdmFleetControls;
